import { clueList } from "@/mocks/manga";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function Clues() {
  return (
    <section id="clues" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-medium tracking-wide text-primary-600">ENDING CLUES</span>
          <h2 className="font-heading mt-2 text-3xl text-foreground-950 md:text-4xl">结局线索追踪</h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            聚焦主线收束期释放的蛛丝马迹，持续追踪角色命运与结局走向，供你一起推断《甜蜜惩罚》的最终归宿。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {clueList.map((clue) => (
            <article
              key={clue.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-full ${toneMap[clue.tone]} text-xl`}>
                <i className={clue.icon} />
              </span>
              <h3 className="font-heading mt-4 text-lg text-foreground-950">{clue.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{clue.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 self-start rounded-full bg-background-200 px-3 py-1 text-xs font-medium text-foreground-700">
                <i className="ri-flashlight-fill text-accent-500" />
                信号强度 · {clue.level}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}